import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-thumbtack-icon',
  templateUrl: './communication-thumbtack.component.html'
})
export class CommunicationThumbtackComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
